import { t } from '@/plugins/i18n'
import type { Ref } from 'vue'
import { checkLoginName } from '@/apis/login'
import { isName, isContractName } from '@/plugins/utils'
import { FormItemRule } from 'element-plus'
import { isJA } from '@/store'

export const login = (disabled: Ref): any => ({
  nameOrEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('用户名不能为空'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],

  password: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('密码不能为空'))
        } else if (
          // /^[\d\w]+$/.test(val) &&
          val.length >= 6 &&
          val.length <= 32
        ) {
          callback()
        } else {
          callback(
            t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val) || val === '') {
          callback()
        } else {
          if (val === '') {
            callback()
          } else {
            callback(t('验证码格式不正确，请重新输入'))
          }
        }
      },
      trigger: ['blur']
    }
  ]
})

export const signup = (form: any, disabled: Ref, passwordErr: Record<string, boolean> | null = null): any => ({
  loginName: [
    { required: true, message: t('用户名不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isName(val)) {
          checkLoginName(val).then((res: any) => {
            if (res.success) {
              callback()
            } else {
              callback(t('该用户名已被注册'))
            }
          })
        } else {
          callback(t('用户名不可用，请重新设置1-18位用户名不支持标点符号'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerName: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isName(val) || !val) {
          callback()
        } else {
          callback(
            t('用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  password: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (passwordErr) {
          if (/^\S{6,32}$/.test(val)) {
            passwordErr.len = true
          } else {
            passwordErr.len = false
          }
          if (/(?=.*[a-zA-Z])(?=.*[0-9])/.test(val)) {
            passwordErr.con = true
          } else {
            passwordErr.con = false
          }
          if (!passwordErr.con || !passwordErr.len) {
            callback(passwordErr)
          } else {
            callback()
          }
        } else {
          if (/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/.test(val)) {
            callback()
          } else {
            callback(
              t(
                '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写'
              )
            )
          }
        }
      },
      trigger: ['blur']
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.password) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      required: true,
      message: t('邮箱格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'change'
    },
    {
      required: true,
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val) || val === '') {
          callback()
        } else {
          if (val === '') {
            callback()
          } else {
            callback(t('验证码格式不正确，请重新输入'))
          }
        }
        callback()
      },
      trigger: ['blur']
    }
  ],
  customerMobile: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val && isJA()) {
          callback()
        }
        if (/^[\d]{6,20}$/.test(val)) {
          callback()
          disabled.value = false
        } else {
          callback(t('手机号格式不正确，请重新输入'))
          disabled.value = true
        }
      },
      trigger: ['blur']
    }
  ],
  isagree: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('同意以下条款'))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ],
  recommendationEmail: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  invitationCode: [
    {
      validator: (_: FormItemRule, val: string, callback: any) => {
        if (val === '' || val === undefined) {
          callback()
          return
        }
        if (/^[a-zA-Z\d-]{6}$/.test(val)) {
          callback()
        } else {
          callback(t('邀请码无效，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const findPwd = (form: any, disabled: Ref): any => ({
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    // {
    //   required: true,
    //   message: t('验证码格式不正确，请重新输入'),
    //   trigger: ['change']
    // },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: ['blur', 'change']
    }
  ],
  newPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if (/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/.test(val)) {
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
          callback()
        } else {
          callback(
            // t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
            t(
              '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写'
            )
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.newPassword) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const changeEmail = (form: any, disabled: Ref): any => ({
  // password: [
  //   { required: true, message: t('密码不能为空'), trigger: 'blur' },
  //   {
  //     validator: (rule: any, val: string, callback: any) => {
  //       if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
  //         callback()
  //       } else {
  //         callback(
  //           t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
  //         )
  //       }
  //     },
  //     trigger: 'blur'
  //   }
  // ],
  password: [{ required: true, message: t('密码不能为空'), trigger: 'blur' }],
  newCustomerEmail: [
    {
      required: true,
      message: t('邮箱格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const setupPwd = (form: any, disabled: Ref): any => ({
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ],
  oldPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' }
    // {
    //   validator: (rule: any, val: string, callback: any) => {
    //     if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
    //       callback()
    //     } else {
    //       callback(
    //         t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
    //       )
    //     }
    //   },
    //   trigger: 'blur'
    // }
  ],
  newPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if (/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/.test(val)) {
          callback()
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
        } else {
          callback(
            // t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
            t(
              '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写'
            )
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.newPassword) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ]
})

// 提现
export const Withdrawal = (form: any, disabled: Ref): any => ({
  withdrawChannelType: [
    { required: true, message: t('请选择提现渠道'), trigger: 'blur' }
  ],
  bankName: [{ required: true, message: t('请输入银行名称'), trigger: 'blur' }],
  bankAddress: [
    { required: true, message: t('请输入支店名'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^.{1,20}$/.test(val)) {
          callback()
        } else {
          callback(t('输入的支店名格式不正确，请设置1-20位字符'))
        }
      },
      trigger: 'blur'
    }
  ],
  kzType: [{ required: true, message: t('请选择口座类别'), trigger: 'blur' }],
  bankNo: [{ required: true, message: t('请输入银行账号'), trigger: 'blur' }],
  beneficiaryName: [
    { required: true, message: t('请输入收款人名称'), trigger: 'blur' }
  ],
  withdrawAmountRmb: [
    { required: true, message: t('请输入提现金额'), trigger: 'blur' }
  ],
  emailCode: [
    { required: true, message: t('请输入验证码'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})
